import React from 'react';
import styled from 'styled-components';
import GlobalStyle from '../../@style/globalStyle';
import screens from '../../@style/screens';
interface Props {
  children: React.ReactNode;
}

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;
  @media ${screens.laptop} {
    padding: 0 5rem;
  }
`;

const Layout: React.FC<Props> = ({ children }) => (
  <>
    <GlobalStyle />
    <LayoutWrapper>{children}</LayoutWrapper>
  </>
);

export default Layout;
